/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Referrals/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import Referral from './Referral/index'



/** @type {import('Simple/types.js').View} */
export default function Referrals({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Referrals"
  
}) {
let profilePatientReferralsValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: 'referrals',
})
  return (<React.Fragment
>
<div
  data-testid="Referrals.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(profilePatientReferralsValueData) && profilePatientReferralsValueData.map((item, index, list) => 
<ListItem
        key={`${item?._id}`}
        context="profile_patient_referral"
        item={item}
        index={index}
        list={list}
        hasItemKey={true}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Referral(${`${item?._id}`})`}
      >
<Referral
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Referral(${`${item?._id}`})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }